export const Colours = {
	light: {
		appBlue: '#00A2E9',
		background: 'white',
		font_header: 'black',
		button_bg: '#00A2E9',
		button_font: 'white',
		dropdown_header: '#707070',
		welcome_font: '#00A2E9', //#048ae8
		top_bar_header: '#5d5d5d',
		//editbox_blur: '#757575',
		//editbox_focus: '#00a2e9',
		normal_font: '#5d5d5d',
		//dashboard_message_bg: '#00A2E9',
		//dashboard_message_bg: '#0F509F',
		midnight_sky: '#30363d',
		dashboard_message_font: 'white',
		system_font: '#777777',
		editbox_placeholder: '#30363d',
		//Operation Screen
		csp_font_colour: '#00A2E9',
		hsp_font_colour: '#c0392b',
		//advanced_setting: '#43aaf5', //#43aaf5
		realtime_bg: '#4D5E72',
		chart_bar: '#16A085',
		button_light_gray: '#bdbdbd',
	},
	dark: {

	},
	//appBlue: '#0098de',
	appBlue: '#00A2E9',
	appRed: '#c0392b',
	appYellow: '#ffff00',
	pumpkin: '#d35400',
	wetasphalt: '#34495e',
	midnightBlue: '#2c3e50',
	midnight_sky: '#30363d',
	greensea: '#16a085',
	emerald: '#2ecc71',
	lightBlue: '#44C8F5',
}